import styled from 'styled-components';
import Form from 'components/form';
import { color } from 'styles/settings';
import { ReactComponent as _TextIcon } from 'styles/icons/text.svg';
import { ReactComponent as _CloseIcon } from 'styles/icons/close-icon.svg';
import { withModifiers } from 'utils/styles';

export const FormContainer = styled.div`
  margin-bottom: -16px;
  margin-right: 20px;
  height: 50px;
`;

export const NameInput = styled(Form.TextInput)`
  background-color: ${color.ui.backgroundGray};
  border-radius: 2px;
  height: 50px;
  width: 143px;
  transition: all 0.3s linear;
  z-index: 2;

  ${withModifiers('$isFocused')`
    :focus-within {
        width: 385px;
     }  
    `}
  ::placeholder {
    color: ${color.neutral.plainBlack};
  }
`;

export const TextIcon = styled(_TextIcon)`
  width: 16px;
  height: 18px;
  padding-left: 16px;
  color: ${color.neutral.plainBlack};
`;

export const CloseIcon = styled(_CloseIcon)`
  width: 16px;
  height: 18px;
  cursor: pointer;
  color: ${color.neutral.plainBlack};
`;

export const DummySpaceComponent = styled.div`
  height: 50px;
  width: 177px;
`;

export const InputContainer = styled.div`
  display: flex;
  z-index: 2;
  flex: 0;
  position: absolute;
  top: 4px;
  left: 4px;
`;
